export default __webpack_public_path__ + "static/media/holiday-2026.8eac1336.pdf";